import { ApiTypeDependency } from '../../targets/type';
import { Rights } from '../../accounts/common/accountRoleAndPrivileges/type';
import { CloudWorkloadSecurityAccountStatus } from '../../cloudWorkloadSecurity/cloudWorkloadSecurityCustomerView/types';
import { MobileSecurityAccountStatus } from '../../mobileSecurity/mobileSecurityCompanyGrid/types';

export const CLOUD_SECURITY_FEATURE = 'cloudWorkloadSecurity';
export const MOBILE_SECURITY_FEATURE = 'cloudMobile';
export const EMAIL_SECURITY_FEATURE = 'cloudUss';

export const featureToId = {
  [CLOUD_SECURITY_FEATURE]: 'cloud-security',
  [MOBILE_SECURITY_FEATURE]: 'mobile-security',
  [EMAIL_SECURITY_FEATURE]: 'email-security',
};

export enum EmailSecurityAccountStatus {
  NOT_STARTED = 0,
  IN_PROGRESS,
  DONE,
  FAILED,
}

export const provisionedStatusMap = {
  'cloud-security': CloudWorkloadSecurityAccountStatus.CREATED,
  'mobile-security': MobileSecurityAccountStatus.CREATED,
  'email-security': EmailSecurityAccountStatus.DONE,
};

export enum TEMPLATE_AREAS {
  HEADER = 'header',
  HEADER_TOP = 'header-top',
  HEADER_MIDDLE = 'header-middle',
  HEADER_BOTTOM = 'header-bottom',
  INTEGRATIONS = 'integrations',
  PRODUCT_TRIALS = 'trials',
  NEWS = 'news',
  MASTERCLASS = 'masterclass',
  BODY_LEFT_TOP = 'body-left-top',
  BODY_RIGHT_TOP = 'body-right-top',
  BODY_LEFT_BOTTOM = 'body-left-bottom',
  BODY_RIGHT_BOTTOM = 'body-right-bottom',
}

export const FEATURES = [CLOUD_SECURITY_FEATURE, MOBILE_SECURITY_FEATURE, EMAIL_SECURITY_FEATURE] as const;

export type IntegrationFeature = typeof FEATURES[number];

export type IntegrationFeatures = {
  [Key in IntegrationFeature]: {
    hasFeature: boolean;
    settings: {
      provisionStatus: number;
    };
  };
};

export interface LandingPageData {
  companyId: string;
  companyType: GzLandingPageCompanyType;
  companyName: string;
  companyHash: string;
  integrationFeatures: IntegrationFeatures;
  userRights: Rights;
  features: {
    inProductTrials: boolean;
  };
}

export interface LandingPageDependencies {
  translateFn: any;
  getUser: Function;
  isCloud: Function;
  api: {
    type?: ApiTypeDependency;
    clients: {
      CloudSecurity: {
        openConsole: Function;
        goToFeature: Function;
      };
      MobileSecurity: {
        openConsole: Function;
        goToFeature: Function;
      };
      EmailSecurity: {
        openConsole: Function;
        goToFeature: Function;
      };
      ProductTrials: {
        goToFeature: Function;
      };
      HelpAndSupport: {
        goToFeature: Function;
      };
      WhatsNew: {
        openWhatsNew: Function;
      };
      InstallationPackages: {
        goToFeature: Function;
      };
      EarlyAccess: {
        goToFeature: Function;
      };
      GzData: {
        getGzVersion: Function;
      };
      CardMessages: {
        getCardMessages: Function;
      },
      RssFeedUrl: {
        getRssFeedUrls: Function;
      };
    };
  };
}

export enum GzLandingPageCompanyType {
  CSPM_STANDALONE = 1,
  CUSTOMER,
  MSP,
  PARTNER,
}

export enum Integrations {
  EMAIL_SECURITY = 1,
  MOBILE_SECURITY,
  CSPM,
}

export interface CardMessage {
  id: string;
  message: string;
  criticality: number;
  publishedOn: string;
}

export interface HomePageSettings {
  newsFeedRssUrls: string[];
}
